import { CARREGAR_USUARIO_LOGADO_SUCESSO } from './actionTypes';

export const carregarUsuarioLogadoSucesso = usuario => {
  return {
    type: CARREGAR_USUARIO_LOGADO_SUCESSO,
    usuario
  };
};